import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Divider, Popover, Stack, Typography } from '@mui/material';
import CustomTextField from '../Reusablecomponents/CustomTextField';
import './IndoorClimate.css';
import CustomButton from '../Reusablecomponents/Custombutton';
import CircularProgress from '@mui/material/CircularProgress';
import climate from '../icons/Climate.png';
import TomatoOutlineIcon from '../icons/tomato_icon_outline.png';
import OrganizationService from '../organizationService';
import CustomButtonStack from '../Reusablecomponents/CustomButtonStack';
import { ReportApi } from "../api";


function IndoorClimate(props) {
    const { sensorData } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorHarvest, setAnchorHarvest] = useState(null);
    const [light, setLight] = useState(sensorData && sensorData.length > 0 ? sensorData[sensorData.length - 1].light_J || '' : '');
    const [t_Day, setT_Day] = useState(sensorData && sensorData.length > 0 ? sensorData[sensorData.length - 1].temperature_day || '' : '');
    const [t_Night, setT_Night] = useState(sensorData && sensorData.length > 0 ? sensorData[sensorData.length - 1].temperature_night || '' : '');
    const [co2, setCo2] = useState(sensorData && sensorData.length > 0 ? sensorData[sensorData.length - 1].CO2_ppm || '' : '');

    const isClimateSimulationEnabled = OrganizationService.isFeatureEnabled(props.orgIdOrUuid, "climateSimulation");
    const isHarvestPlanningEnabled = OrganizationService.isFeatureEnabled(props.orgIdOrUuid, "harvestPlanning");
    const isOfflinePredictionEnabled = OrganizationService.isFeatureEnabled(props.orgIdOrUuid, "offlinePrediction");

    useEffect(() => {
        if (sensorData && sensorData.length > 0) {
            const lastData = sensorData[sensorData.length - 1];
            setLight(lastData.light_J >= 0 ? parseFloat(lastData.light_J).toFixed(2) : '');
            setT_Day(lastData.temperature_day >= 0 ? parseFloat(lastData.temperature_day).toFixed(2) : '');
            setT_Night(lastData.temperature_night >= 0 ? parseFloat(lastData.temperature_night).toFixed(2) : '');
            setCo2(lastData.CO2_ppm >= 0 ? parseFloat(lastData.CO2_ppm).toFixed(2) : '');
        }
    }, [props.sensorData]);
    const defaultLight = sensorData && sensorData.length > 0 ? parseFloat(sensorData[sensorData.length - 1].light_J || '').toFixed(2) : '';
    const defaultT_Day = sensorData && sensorData.length > 0 ? parseFloat(sensorData[sensorData.length - 1].temperature_day || '').toFixed(2) : '';
    const defaultT_Night = sensorData && sensorData.length > 0 ? parseFloat(sensorData[sensorData.length - 1].temperature_night || '').toFixed(2) : '';
    const defaultCo2 = sensorData && sensorData.length > 0 ? parseFloat(sensorData[sensorData.length - 1].CO2_ppm || '').toFixed(2) : '';

    const [fetchError, setFetchError] = useState(false);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isClimatePopoverOpen, setIsClimatePopoverOpen] = useState(false);
    const [isHarvestPopoverOpen, setIsHarvestPopoverOpen] = useState(false);
    const [isClimateButtonHovered, setIsClimateButtonHovered] = useState(false);
    const [isHarvestButtonHovered, setIsHarvestButtonHovered] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [isFirstTimeF, setIsFirstTimeF] = useState(true)

    const [currentHarvest, setCurrentHarvest] = useState();
    const [futureHarvest, setFutureHarvest] = useState();
    const [isSave, setIsSave] = useState(false);

    const [currentHarvestableFruits, setCurrentHarvestableFruits] = useState(0);
    const [futureHarvestableFruits, setFutureHarvestableFruits] = useState(0);
    const [currentCW, setCurrentCW] = useState(0);
    const [futureCW, setFutureCW] = useState(0);
    useEffect(() => {
        setIsSave(true);
        setCurrentHarvestableFruits(0);
        setFutureHarvestableFruits(0);
        setCurrentHarvest(undefined);
        setFutureHarvest(undefined);
        props.setYieldPrediction([]);
    }, [props.cropId])

    useEffect(() => {
        if (!isSave || !props.cropId || !props.baseHarvestData) return;

        const fetchData = async () => {
            setIsLoading(true);
            if (props.yieldPrediction && props.yieldPrediction.length > 0) {
                props.setPreviousPredictionValues([props.yieldPrediction[0].yield_prediction, props.yieldPrediction[1].yield_prediction])
            }

            let apiRequest;
            const futureHarvestWeight = props.futureHarvestData !== undefined ? props.futureHarvestData : props.baseHarvestData.harvested_weight_future;
            {/*  if (props.orgIdOrUuid == "3add61f3-029b-4523-840f-aa19727a2337") {
                if (props.cropId === 147 || props.cropId === 24 || props.cropId === 39) {
                    apiRequest = [
                        { date_time: "2025-04-14T00:00:00Z", calendar_week: 16, yield_prediction: 10378 },
                        { date_time: "2025-04-21T00:00:00Z", calendar_week: 17, yield_prediction: 6593 },
                        { date_time: "2025-04-28T00:00:00Z", calendar_week: 18, yield_prediction: 6777 },
                    ];
                } else if (props.cropId === 148 || props.cropId === 25 || props.cropId === 40) {
                    apiRequest = [
                        { date_time: "2025-04-14T00:00:00Z", calendar_week: 16, yield_prediction: 8012 },
                        { date_time: "2025-04-21T00:00:00Z", calendar_week: 17, yield_prediction: 5086 },
                        { date_time: "2025-04-28T00:00:00Z", calendar_week: 18, yield_prediction: 5066 },
                    ];
                }
            } */}

            if (isOfflinePredictionEnabled) {
                apiRequest = ReportApi.fetchOfflinePrediction(props.cropId);
            } else {
                if (light > 0 && t_Day > 0 && t_Night > 0 && co2 > 0) {
                    apiRequest = ReportApi.fetchPrediction(props.cropId, currentHarvest || props.baseHarvestData.harvested_weight, futureHarvest || futureHarvestWeight, light, t_Day, t_Night, co2);
                } else {
                    apiRequest = ReportApi.fetchPrediction(props.cropId, currentHarvest || props.baseHarvestData.harvested_weight, futureHarvest || futureHarvestWeight);
                }
            }

            try {
                const initialData = await apiRequest;
                const data = isOfflinePredictionEnabled ? initialData.predictions : initialData;
                if (isOfflinePredictionEnabled && isHarvestPlanningEnabled && futureHarvest && data.length > 0) {
                    const addValue = parseFloat(futureHarvest);
                    if (!isNaN(addValue)) {
                        const harvestValue = data[0].yield_prediction - addValue
                        data[data.length - 1].yield_prediction += harvestValue;
                    }
                }
                props.setYieldPrediction(data);
                const mergedData = [props.baseHarvestData, ...data];
                const handleDuplicates = (data) => {
                    let seenWeeks = new Set();
                    return data.map(item => {
                        let calendarWeek = item.calendar_week;
                        while (seenWeeks.has(calendarWeek)) {
                            calendarWeek += 1;
                        }
                        seenWeeks.add(calendarWeek);
                        return { ...item, calendar_week: calendarWeek };
                    });
                };

                const finalMergedData = handleDuplicates(mergedData);
                setCurrentHarvestableFruits(Math.floor(finalMergedData[0].prognosis));
                setFutureHarvestableFruits(Math.floor(finalMergedData[1].yield_prediction));
                setCurrentCW(Math.floor(finalMergedData[0].calendar_week));
                setFutureCW(Math.floor(finalMergedData[1].calendar_week));
                if (!currentHarvest && !futureHarvest) {
                    setCurrentHarvest(props.baseHarvestData.harvested_weight);
                    if (isHarvestPlanningEnabled && finalMergedData?.[1]?.yield_prediction != null) {
                        setFutureHarvest(Math.floor(finalMergedData[1].yield_prediction));
                    } else {
                        setFutureHarvest(props.baseHarvestData.harvested_weight_future);
                    }
                }
            } catch (error) {
                console.error(error);
                setFetchError(true);
            } finally {
                setIsLoading(false);
                setIsSave(false);
            }
        };

        fetchData(props.cropId);
    }, [isSave, currentHarvest, futureHarvest, props.cropId, props.baseHarvestData, props.sensorData, light, t_Day, t_Night, co2]);



    useEffect(() => {
        props.getHarvestValues(currentHarvest, futureHarvest, false);
    }, [currentHarvest, futureHarvest]);

    const handleClimateMouseEnter = () => {
        setIsClimateButtonHovered(true);
        setIsClimatePopoverOpen(true);
    };

    const handleClimateMouseLeave = () => {
        setIsClimateButtonHovered(false);
        setIsClimatePopoverOpen(false);
    };


    const handleHarvestMouseEnter = () => {
        setIsHarvestButtonHovered(true);
        setIsHarvestPopoverOpen(true);
    };

    const handleHarvestMouseLeave = () => {
        setIsHarvestButtonHovered(false);
        setIsHarvestPopoverOpen(false);
    };


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setIsButtonClicked(true);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setIsButtonClicked(false);
    };

    const handleSave = async () => {
        setIsSave(true);
        await ReportApi.fetchPrediction(
            props.cropId,
            currentHarvest || props.baseHarvestData.harvested_weight,
            futureHarvest || props.baseHarvestData.harvested_weight,
            light,
            t_Day,
            t_Night,
            co2
        );
        handleClose();


        const lastObjectIndex = props.sensorData.length - 1;
        if (lastObjectIndex >= 0) {
            sensorData[lastObjectIndex] = {
                ...sensorData[lastObjectIndex],
                light_J: light,
                temperature_day: t_Day,
                temperature_night: t_Night,
                CO2_ppm: co2,
            };
        }

        props.setSensorData(sensorData);
    };

    const handleHarvestPopoverOpen = (event) => {
        setAnchorHarvest(event.currentTarget);
        setIsClimatePopoverOpen(true);
    };

    const handleHarvestDone = () => {
        handleCloseHarvestPopover();
        props.getHarvestValues(currentHarvest, futureHarvest, true)
        setIsSave(true)
    };


    const handleCloseHarvestPopover = () => {
        setAnchorHarvest(null);
    };
    const handleChange = (event) => {
        const value = event.target.value.trim();
        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
            setLight(value);
        }
    };

    const handleChangeT_Day = (event) => {
        const value = event.target.value.trim();
        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
            setT_Day(value);
        }
    };

    const handleChangeT_Night = (event) => {
        const value = event.target.value.trim();
        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
            setT_Night(value);
        }
    };

    const handleChangeCo2 = (event) => {
        const value = event.target.value.trim();
        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
            setCo2(value);
        }
    };



    const handleCurrentScheduledHarvestChange = (event) => {
        setIsFirstTime(false);
        const value = event.target.value.trim();
        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
            setCurrentHarvest(value);
        }
    };

    const handleFutureScheduledHarvestChange = (event) => {
        setIsFirstTimeF(false);
        const value = event.target.value.trim();
        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
            setFutureHarvest(value);

        }
    };

    const open = Boolean(anchorEl);
    const id = open ? 'indoor-climate-popover' : undefined;
    const openHarvestPopover = Boolean(anchorHarvest);
    const saveButtonRef = useRef(null);
    return (
        <div>
            {isLoading && !props.noData ? (
                <div className="loading-overlay">
                    <CircularProgress size={40} style={{ color: '#05668D' }} />
                </div>
            ) : (
                <Stack direction="row" spacing={3} alignItems="center">
                    {isClimateSimulationEnabled && (
                        <CustomButton
                            sx={{ color: "white", }}
                            onClick={handleClick}
                            onMouseEnter={handleClimateMouseEnter}
                            onMouseLeave={handleClimateMouseLeave}
                            backgroundColor="#6B6B6B"
                            hoverBackgroundColor="#05668D"
                            activeBackgroundColor="#05668D"
                            icon={climate}
                            label="Simulate climate Change"
                            disabled={props.noData}
                        />)}
                    <Popover
                        className="popover_class"
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        PaperProps={{
                            style: {
                                borderRadius: '6px',
                                marginTop: '10px',
                            },
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                saveButtonRef.current.click();
                                handleClose();
                            }
                        }}
                    >
                        {/* Popover content */}
                        <Box sx={{ p: 2 }}>
                            <Stack spacing={2}>
                                <Box sx={{ my: 1 }}>
                                    <Typography variant="h6" sx={{ color: '#05668D', fontWeight: '600' }}>
                                        Simulate indoor climate
                                    </Typography>
                                    <Divider />
                                </Box>
                                <CustomTextField
                                    label={`Light (800-20000 Joule, default: ${defaultLight})`}
                                    value={light || ''}
                                    onChange={handleChange}
                                />
                                <CustomTextField
                                    label={`Day_Temp (18-27 °C, default: ${defaultT_Day})`}
                                    value={t_Day || ''}
                                    onChange={handleChangeT_Day}
                                />
                                <CustomTextField
                                    label={`Night_Temp (14-18 °C, default: ${defaultT_Night})`}
                                    value={t_Night || ''}
                                    onChange={handleChangeT_Night}
                                />
                                <CustomTextField
                                    label={`CO2 (300 - 850 ppm, default: ${defaultCo2})`}
                                    value={co2 || ''}
                                    onChange={handleChangeCo2}
                                />
                                <CustomButtonStack
                                    onCancelClick={handleClose}
                                    onButtonClick={handleSave}
                                    isDisabled={!light}
                                    cancelLabel="Cancel"
                                    sendLabel="Done"
                                    height="32px"
                                    width="82px"
                                    saveButtonRef={saveButtonRef}
                                />
                            </Stack>
                        </Box>
                    </Popover>
                    {isHarvestPlanningEnabled && (
                        <CustomButton
                            sx={{ color: "white", }}
                            onClick={handleHarvestPopoverOpen}
                            onMouseEnter={handleHarvestMouseEnter}
                            onMouseLeave={handleHarvestMouseLeave}
                            backgroundColor="#6B6B6B"
                            hoverBackgroundColor="#05668D"
                            activeBackgroundColor="#05668D"
                            icon={TomatoOutlineIcon}
                            label="Add harvest plan"
                            disabled={props.noData}
                        />)}
                    <Popover
                        id="harvest-popover"
                        open={openHarvestPopover}
                        anchorEl={anchorHarvest}
                        onClose={handleCloseHarvestPopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        PaperProps={{
                            style: {
                                borderRadius: '6px',
                                marginTop: '10px',
                            },
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                saveButtonRef.current.click();
                                handleClose();
                            }
                        }}
                    >
                        {/* Harvest popover content */}
                        <Box sx={{ p: 1 }}>
                            <Stack spacing={2}>
                                <Box sx={{ my: 1 }}>
                                    <Typography variant="h6" sx={{ color: '#05668D', fontWeight: '600' }}>
                                        Add harvest plan
                                    </Typography>
                                    <Divider />
                                </Box>
                                <CustomTextField
                                    label={`CW${futureCW}, (Max ${futureHarvestableFruits.toFixed(2)} kg)`}
                                    value={futureHarvest || ''}
                                    onChange={handleFutureScheduledHarvestChange}
                                />
                                <CustomButtonStack
                                    onCancelClick={handleCloseHarvestPopover}
                                    onButtonClick={handleHarvestDone}
                                    saveButtonRef={saveButtonRef}
                                    isDisabled={!futureHarvest}
                                    cancelLabel="Cancel"
                                    sendLabel="Done"
                                    height="32px"
                                    width="82px"
                                />
                            </Stack>
                        </Box>
                    </Popover>
                </Stack>
            )}

        </div>
    );
}

export default IndoorClimate;